/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast. Keeping your custom
 * Javascript in this file will make it easier to update Broadcast. In order
 * to use this file, open layout/theme.liquid and uncomment the custom.js
 * script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line.
})();

document.addEventListener('DOMContentLoaded', function () {
  const fakeSearch = document.querySelector('[data-open-mobile-search]');
  const realSearchDetails = document.querySelector(
    '.header__mobile__left header-search-popdown details'
  );

  if (!fakeSearch || !realSearchDetails) return;

  fakeSearch.addEventListener('click', function () {
    realSearchDetails.setAttribute('open', '');

    setTimeout(function () {
      const input = document.querySelector('#SearchInput--mobile');

      if (input) {
        input.removeAttribute('tabindex');
        input.setAttribute('tabindex', '0');
        input.focus();
      }
    }, 150);
  });
});

/* -------------------------------------------------------------------------- */
/* Collection cards: variants, swatches, Single/Pair, pricing and ATC         */
/* -------------------------------------------------------------------------- */

const CC_EXCLUDED_PAIR_HANDLES = [
  'dolphin-flat-back-stud-right',
  'mini-skeleton-hand-flat-back-stud',
  'pumpkin-pie-enamel-flat-back-stud',
  'toasted-mallow-enamel-flat-back-stud',
  'number-flat-back-studs'
];

const CC_EXCLUDED_CHARM_PAIR_HANDLES = [
  'cookies-and-milk-charm',
  'corn-dog-enamel-hoop-charm',
  'watering-can-enamel-hoop-charm-left',
  'scissors-enamel-hoop-charm',
  'school-bus-enamel-hoop-charm'
];

/*
 * Default Pair visual discount on all collections
 * for charms and flat-back-studs.
 */
const CC_DEFAULT_PAIR_DISCOUNT = 0.1;

/*
 * Collection-page visual sale.
 *
 * Key = collection handle from /collections/HANDLE
 * Example: https://cordsclub.com/collections/endless-summer-sale
 *          → handle is "endless-summer-sale"
 *
 * discount:
 *   0.3 = 30% off
 *
 * applyToAllProducts:
 *   true  = also discount cards without Single/Pair
 *           (bracelets, etc.)
 *   false = only charms / flat-back-studs Pair (and Single
 *           on those same cards)
 *
 * Leave this object empty when no collection sale is running.
 */
const CC_COLLECTION_SALES = {
  // 'endless-summer-sale': {
  //   discount: 0.3,
  //   applyToAllProducts: true
  // }
};

function ccGetCurrentCollectionHandle() {
  const path = window.location.pathname;

  if (path.includes('/products/')) {
    return '';
  }

  return (
    path.match(/\/collections\/([^/?#]+)/)?.[1] || ''
  ).toLowerCase();
}

function ccGetActiveCollectionSale() {
  const handle = ccGetCurrentCollectionHandle();
  const sale = CC_COLLECTION_SALES[handle];

  if (
    !sale ||
    !Number.isFinite(sale.discount) ||
    sale.discount <= 0
  ) {
    return null;
  }

  return sale;
}

function ccGetPairDiscountRate() {
  const sale = ccGetActiveCollectionSale();

  if (sale) {
    return sale.discount;
  }

  return CC_DEFAULT_PAIR_DISCOUNT;
}

function ccGetPairPriceMultiplier() {
  return 1 - ccGetPairDiscountRate();
}

function ccCollectionSaleAppliesToAllProducts() {
  const sale = ccGetActiveCollectionSale();

  return Boolean(sale?.applyToAllProducts);
}

function ccGetPairPriceMultiplier() {
  return 1 - ccGetPairDiscountRate();
}

function ccFormatMoney(cents) {
  const numericCents = Number(cents);

  if (!Number.isFinite(numericCents)) {
    return '';
  }

  const currencyCode =
    window.CC_ACTIVE_CURRENCY;

  const locale =
    window.CC_ACTIVE_LOCALE ||
    document.documentElement.lang ||
    navigator.language ||
    'en-US';

  if (!currencyCode) {
    return (
      (numericCents / 100).toFixed(2)
    );
  }

  try {
    return new Intl.NumberFormat(
      locale,
      {
        style: 'currency',
        currency: currencyCode,
        currencyDisplay: 'symbol',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }
    ).format(
      numericCents / 100
    );
  } catch (error) {
    return (
      currencyCode +
      ' ' +
      (numericCents / 100).toFixed(2)
    );
  }
}

function ccParseMoneyToCents(value) {
  const text = String(value || '').trim();
  const matches = text.match(
    /-?\d[\d,]*(?:\.\d+)?/g
  );

  if (!matches || !matches.length) {
    return 0;
  }

  const number = Number(
    matches[matches.length - 1].replace(/,/g, '')
  );

  return Number.isFinite(number)
    ? Math.round(number * 100)
    : 0;
}

function ccGetGridItem(element) {
  return (
    element?.closest(
      '[data-grid-item], grid-item.product-item, grid-item'
    ) || null
  );
}

function ccGetCardUrlText(card) {
  const gridItem = ccGetGridItem(card);
  const scope = gridItem || card;

  return [
    scope?.getAttribute('data-url'),

    scope
      ?.querySelector('.product-link[href]')
      ?.getAttribute('href'),

    scope
      ?.querySelector(
        '.product-link[data-product-link]'
      )
      ?.getAttribute('data-product-link'),

    scope
      ?.querySelector(
        '[data-quick-add-modal-handle]'
      )
      ?.getAttribute(
        'data-quick-add-modal-handle'
      ),

    scope
      ?.querySelector('[data-swatch-handle]')
      ?.getAttribute('data-swatch-handle'),

    ...Array.from(
      scope?.querySelectorAll('a[href]') || []
    ).map(function (link) {
      return link.getAttribute('href');
    })
  ]
    .filter(Boolean)
    .join(' ');
}

/*
 * Controls whether Pair receives the
 * visual discount.
 */
function ccCardUsesPairDiscount(card) {
  if (ccGetPairDiscountRate() <= 0) {
    return false;
  }

  const productType = String(
    card?.dataset.productType || ''
  )
    .trim()
    .toLowerCase();

  return (
    productType === 'charms' ||
    productType === 'flat-back-studs'
  );
}

/*
 * Controls whether Pair is selected
 * automatically when the card loads.
 */
function ccCardDefaultsToPair(card) {
  const productType = String(
    card?.dataset.productType || ''
  )
    .trim()
    .toLowerCase();

  const possibleText =
    ccGetCardUrlText(card);

  if (productType === 'charms') {
    return !CC_EXCLUDED_CHARM_PAIR_HANDLES.some(
      function (handle) {
        return possibleText.includes(handle);
      }
    );
  }

  if (productType === 'flat-back-studs') {
    return !CC_EXCLUDED_PAIR_HANDLES.some(
      function (handle) {
        return possibleText.includes(handle);
      }
    );
  }

  return false;
}

function ccGetCompareAtSettingElement(card) {
  return (
    card.closest(
      '[data-show-compare-at-price]'
    ) ||
    ccGetGridItem(card)?.querySelector(
      '[data-show-compare-at-price]'
    ) ||
    document.querySelector(
      '[data-show-compare-at-price]'
    )
  );
}

function ccCompareAtEnabled(card) {
  const settingElement =
    ccGetCompareAtSettingElement(card);

  const explicitValue =
    settingElement?.getAttribute(
      'data-show-compare-at-price'
    );

  if (explicitValue === 'false') {
    return false;
  }

  return true;
}

function ccGetSelectedVariantOption(card) {
  const variantSelect = card.querySelector(
    '[data-cc-variant-select]'
  );

  if (!variantSelect) {
    return null;
  }

  return (
    variantSelect.selectedOptions?.[0] ||
    variantSelect.options?.[
      variantSelect.selectedIndex
    ] ||
    variantSelect.querySelector('option')
  );
}

function ccReadOptionCompareAtPrice(option) {
  if (!option) {
    return 0;
  }

  const possibleValues = [
    option.dataset.compareAtPrice,
    option.dataset.comparePrice,
    option.dataset.compareAt,
    option.getAttribute(
      'data-compare-at-price'
    ),
    option.getAttribute(
      'data-compare-price'
    )
  ];

  for (const value of possibleValues) {
    const number = Number(value);

    if (
      Number.isFinite(number) &&
      number > 0
    ) {
      return number;
    }
  }

  return 0;
}

function ccFindCompareAtElement(priceElement) {
  if (!priceElement) {
    return null;
  }

  const explicitCompare =
    priceElement.querySelector(
      [
        's',
        'del',
        '.old-price',
        '.price__compare',
        '.product-item__price--compare',
        '[data-compare-price]',
        '[data-compare-at-price]'
      ].join(',')
    );

  if (explicitCompare) {
    return explicitCompare;
  }

  const salePrice =
    priceElement.querySelector(
      [
        '.price-item--sale',
        '.sale-price',
        '.product-item__price--sale'
      ].join(',')
    );

  if (salePrice) {
    return priceElement.querySelector(
      '.price-item--regular'
    );
  }

  return null;
}

function ccCaptureInitialGridPrice(card) {
  if (
    !card ||
    card.dataset.ccInitialPriceCaptured ===
      'true'
  ) {
    return;
  }

  const gridItem = ccGetGridItem(card);

  const priceElement =
    gridItem?.querySelector(
      '[data-product-price]'
    );

  const selectedOption =
    ccGetSelectedVariantOption(card);

  if (!priceElement || !selectedOption) {
    return;
  }

  const compareAtElement =
    ccFindCompareAtElement(priceElement);

  const compareAtCents =
    compareAtElement
      ? ccParseMoneyToCents(
          compareAtElement.textContent
        )
      : 0;

  card.dataset.ccInitialPriceCaptured =
    'true';

  card.dataset.ccInitialVariantId =
    String(selectedOption.value || '');

  card.dataset.ccInitialCompareAtPrice =
    String(compareAtCents || 0);

  card.dataset.ccInitialHadCompareAt =
    compareAtCents > 0
      ? 'true'
      : 'false';
}

function ccGetActualCompareAtPrice(
  card,
  selectedOption,
  variantPrice
) {
  const optionCompareAt =
    ccReadOptionCompareAtPrice(
      selectedOption
    );

  if (optionCompareAt > variantPrice) {
    return optionCompareAt;
  }

  const initialVariantId =
    card.dataset.ccInitialVariantId;

  const selectedVariantId =
    String(selectedOption?.value || '');

  const cachedCompareAt = Number(
    card.dataset.ccInitialCompareAtPrice || 0
  );

  if (
    initialVariantId &&
    selectedVariantId === initialVariantId &&
    Number.isFinite(cachedCompareAt) &&
    cachedCompareAt > variantPrice
  ) {
    return cachedCompareAt;
  }

  return 0;
}

function ccRenderGridCardPrice(
  priceElement,
  currentPrice,
  compareAtPrice,
  showCompareAt
) {
  if (!priceElement) {
    return;
  }

  const hasCompareAt =
    showCompareAt &&
    Number.isFinite(compareAtPrice) &&
    compareAtPrice > currentPrice;

  if (hasCompareAt) {
    priceElement.innerHTML = `
      <s class="old-price product-item__price--compare">
        ${ccFormatMoney(compareAtPrice)}
      </s>

      <span class="sale-price product-item__price--sale">
        ${ccFormatMoney(currentPrice)}
      </span>
    `;
  } else {
    priceElement.innerHTML = `
      <span class="regular-price product-item__price--regular">
        ${ccFormatMoney(currentPrice)}
      </span>
    `;
  }
}

function ccUpdateGridCardPrice(card) {
  if (!card) {
    return;
  }

  ccCaptureInitialGridPrice(card);

  const variantSelect = card.querySelector(
    '[data-cc-variant-select]'
  );

  const quantitySelect = card.querySelector(
    '[data-cc-qty-select]'
  );

  const gridItem = ccGetGridItem(card);

  const priceElement =
    gridItem?.querySelector(
      '[data-product-price]'
    );

  if (
    !variantSelect ||
    !quantitySelect ||
    !priceElement
  ) {
    return;
  }

  const selectedOption =
    ccGetSelectedVariantOption(card);

  if (!selectedOption) {
    return;
  }

  const variantPrice = Number(
    selectedOption.dataset.price || 0
  );

  const quantity = Math.max(
    1,
    Number(quantitySelect.value || 1)
  );

  if (
    !Number.isFinite(variantPrice) ||
    variantPrice <= 0
  ) {
    return;
  }

  const saleAppliesToAllProducts =
    ccCollectionSaleAppliesToAllProducts();

  const pairDiscountApplies =
    quantity === 2 &&
    ccCardUsesPairDiscount(card);

  const singleDiscountApplies =
    quantity === 1 &&
    ccGetActiveCollectionSale() &&
    (
      saleAppliesToAllProducts ||
        ccCardUsesPairDiscount(card)
    );

  const currentPrice =
    pairDiscountApplies
      ? Math.round(
          variantPrice *
            2 *
            ccGetPairPriceMultiplier()
        )
      : singleDiscountApplies
        ? Math.round(
            variantPrice *
              ccGetPairPriceMultiplier()
          )
        : variantPrice * quantity;

  const actualCompareAtPrice =
    ccGetActualCompareAtPrice(
      card,
      selectedOption,
      variantPrice
    );

  let compareAtPrice = 0;

  if (pairDiscountApplies) {
    /*
     * Crossed price:
     * single variant price × 2
     */
    compareAtPrice =
      variantPrice * 2;
  } else if (singleDiscountApplies) {
    /*
     * Single visual discount on endless-summer-sale.
     */
    compareAtPrice =
      variantPrice;
  } else if (
    actualCompareAtPrice > variantPrice
  ) {
    /*
     * Preserve normal Shopify compare-at
     * when no visual campaign discount applies.
     */
    compareAtPrice =
      actualCompareAtPrice * quantity;
  }

  ccRenderGridCardPrice(
    priceElement,
    currentPrice,
    compareAtPrice,
    pairDiscountApplies ||
      singleDiscountApplies ||
      ccCompareAtEnabled(card)
  );

  const singlePriceElement =
    card.querySelector(
      '[data-cc-single-price]'
    );

  const pairPriceElement =
    card.querySelector(
      '[data-cc-pair-price]'
    );

  if (singlePriceElement) {
    if (singleDiscountApplies) {
      singlePriceElement.innerHTML = `
        <s
          class="cc-pair-option-compare-price"
          style="
            opacity: 0.6;
            margin-right: 5px;
            text-decoration: line-through;
          "
        >
          ${ccFormatMoney(
            variantPrice
          )}
        </s>

        <span class="cc-pair-option-discount-price">
          ${ccFormatMoney(
            Math.round(
              variantPrice *
                ccGetPairPriceMultiplier()
            )
          )}
        </span>
      `;
    } else {
      singlePriceElement.textContent =
        ccFormatMoney(
          variantPrice
        );
    }
  }

  if (pairPriceElement) {
    const regularPairPrice =
      variantPrice * 2;

    const hasPairDiscount =
      ccCardUsesPairDiscount(card);

    const discountedPairPrice =
      Math.round(
        regularPairPrice *
          ccGetPairPriceMultiplier()
      );

    if (hasPairDiscount) {
      pairPriceElement.innerHTML = `
        <s
          class="cc-pair-option-compare-price"
          style="
            opacity: 0.6;
            margin-right: 5px;
            text-decoration: line-through;
          "
        >
          ${ccFormatMoney(
            regularPairPrice
          )}
        </s>

        <span class="cc-pair-option-discount-price">
          ${ccFormatMoney(
            discountedPairPrice
          )}
        </span>
      `;
    } else {
      pairPriceElement.textContent =
        ccFormatMoney(
          regularPairPrice
        );
    }
  }
}

function ccGetActiveColorFromCard(
  gridItem
) {
  const activeSwatch =
    gridItem?.querySelector(
      '[data-swatch-button].cc-color-selected'
    );

  if (!activeSwatch) {
    return null;
  }

  return (
    activeSwatch.dataset.tooltip ||
    activeSwatch
      .querySelector(
        '[data-swatch-text]'
      )
      ?.textContent?.trim() ||
    null
  );
}

function ccSelectVariantByOptions(
  card,
  colorValue,
  nonColorValue
) {
  const variantSelect = card.querySelector(
    '[data-cc-variant-select]'
  );

  if (!variantSelect) {
    return;
  }

  const matchingOption =
    Array.from(
      variantSelect.options
    ).find(function (option) {
      const fullTitle =
        option.textContent
          .trim()
          .toLowerCase();

      const displayTitle =
        (
          option.dataset.displayTitle ||
          ''
        )
          .trim()
          .toLowerCase();

      const colorMatches =
        colorValue
          ? fullTitle.includes(
              colorValue.toLowerCase()
            )
          : true;

      const nonColorMatches =
        nonColorValue
          ? displayTitle ===
            nonColorValue.toLowerCase()
          : true;

      return (
        colorMatches &&
        nonColorMatches &&
        !option.disabled
      );
    });

  if (matchingOption) {
    variantSelect.value =
      matchingOption.value;

    ccUpdateGridCardPrice(card);
  }
}

function ccUpdateGridImage(
  gridItem,
  swatchButton
) {
  if (!gridItem || !swatchButton) {
    return;
  }

  const variantTitle =
    swatchButton.dataset
      ?.swatchVariantName;

  if (
    variantTitle &&
    window.CSS &&
    window.CSS.escape
  ) {
    const match =
      gridItem.querySelector(
        '.product-item__bg__inner' +
          '[data-variant-title="' +
          window.CSS.escape(
            variantTitle
          ) +
          '"] img'
      );

    const defaultImage =
      gridItem.querySelector(
        '[data-product-image-default] img'
      );

    if (match && defaultImage) {
      defaultImage.src = match.src;

      defaultImage.removeAttribute(
        'srcset'
      );

      defaultImage.removeAttribute(
        'sizes'
      );
    }
  }

  const swatchImage =
    swatchButton.dataset?.swatchImage;

  if (swatchImage) {
    const imageUrl =
      swatchImage.startsWith('//')
        ? swatchImage
        : '//cordsclub.com/cdn/shop/' +
          swatchImage;

    const activeSlide =
      gridItem.querySelector(
        '.product-item__bg__slide.is-selected'
      ) ||
      gridItem.querySelector(
        '.product-item__bg__slide'
      );

    if (activeSlide) {
      const image =
        activeSlide.querySelector('img');

      if (image) {
        image.src = imageUrl;

        image.removeAttribute(
          'srcset'
        );
      }
    }
  }
}

function ccHandleSwatchSelection(event) {
  const swatchLink =
    event.target.closest(
      '[data-swatch-link]'
    );

  if (!swatchLink) {
    return;
  }

  event.preventDefault();
  event.stopPropagation();

  const swatchButton =
    swatchLink.closest(
      '[data-swatch-button]'
    );

  const gridItem =
    swatchLink.closest(
      '[data-grid-item], grid-item'
    );

  const card =
    gridItem?.querySelector(
      '[data-cc-grid-cart]'
    );

  if (
    !swatchButton ||
    !gridItem ||
    !card
  ) {
    return;
  }

  gridItem
    .querySelectorAll(
      '[data-swatch-button]'
    )
    .forEach(function (item) {
      item.classList.remove(
        'cc-color-selected'
      );
    });

  swatchButton.classList.add(
    'cc-color-selected'
  );

  ccUpdateGridImage(
    gridItem,
    swatchButton
  );

  const colorValue =
    swatchButton.dataset.tooltip ||
    swatchButton
      .querySelector(
        '[data-swatch-text]'
      )
      ?.textContent?.trim();

  const visibleVariantDropdown =
    card.querySelector(
      '[data-cc-variant-display-select]'
    );

  const nonColorValue =
    visibleVariantDropdown
      ? visibleVariantDropdown.value
      : null;

  ccSelectVariantByOptions(
    card,
    colorValue,
    nonColorValue
  );
}

document.addEventListener(
  'change',
  function (event) {
    if (
      !event.target.matches(
        [
          '[data-cc-variant-select]',
          '[data-cc-qty-select]'
        ].join(',')
      )
    ) {
      return;
    }

    const card =
      event.target.closest(
        '[data-cc-grid-cart]'
      );

    if (!card) {
      return;
    }

    ccUpdateGridCardPrice(card);
  }
);

document.addEventListener(
  'change',
  function (event) {
    if (
      !event.target.matches(
        '[data-cc-variant-display-select]'
      )
    ) {
      return;
    }

    const card =
      event.target.closest(
        '[data-cc-grid-cart]'
      );

    if (!card) {
      return;
    }

    const gridItem =
      ccGetGridItem(card);

    const selectedDisplayTitle =
      event.target.value;

    const selectedColor =
      ccGetActiveColorFromCard(
        gridItem
      );

    ccSelectVariantByOptions(
      card,
      selectedColor,
      selectedDisplayTitle
    );
  }
);

document.addEventListener(
  'pointerdown',
  function (event) {
    if (
      !event.target.closest(
        '[data-swatch-link]'
      )
    ) {
      return;
    }

    ccHandleSwatchSelection(event);
  },
  true
);

document.addEventListener(
  'click',
  function (event) {
    if (
      !event.target.closest(
        '[data-swatch-link]'
      )
    ) {
      return;
    }

    ccHandleSwatchSelection(event);
  },
  true
);

document.addEventListener(
  'click',
  function (event) {
    const pairOption =
      event.target.closest(
        '[data-cc-pair-option]'
      );

    const pairDropdown =
      event.target.closest(
        '[data-cc-pair-dropdown]'
      );

    document
      .querySelectorAll(
        '[data-cc-pair-dropdown].active_dps'
      )
      .forEach(function (dropdown) {
        if (
          !dropdown.contains(
            event.target
          )
        ) {
          dropdown.classList.remove(
            'active_dps'
          );
        }
      });

    if (pairOption) {
      const dropdown =
        pairOption.closest(
          '[data-cc-pair-dropdown]'
        );

      const card =
        pairOption.closest(
          '[data-cc-grid-cart]'
        );

      if (!dropdown || !card) {
        return;
      }

      const quantityInput =
        dropdown.querySelector(
          '[data-cc-qty-select]'
        );

      const label =
        dropdown.querySelector(
          '[data-cc-pair-label]'
        );

      const quantity = Math.max(
        1,
        Number(
          pairOption.dataset.value || 1
        )
      );

      const isPair = quantity === 2;

      card.dataset.ccManualSelection =
        isPair
          ? 'pair'
          : 'single';

      card
        .querySelector(
          '.single-button'
        )
        ?.classList.toggle(
          'active',
          !isPair
        );

      card
        .querySelector(
          '.pair-button'
        )
        ?.classList.toggle(
          'active',
          isPair
        );

      if (quantityInput) {
        quantityInput.value =
          String(quantity);

        quantityInput.setAttribute(
          'value',
          String(quantity)
        );
      }

      if (label) {
        label.textContent =
          pairOption.dataset.name ||
          (
            isPair
              ? 'Pair'
              : 'Single'
          );
      }

      dropdown.classList.remove(
        'active_dps'
      );

      ccUpdateGridCardPrice(card);
      return;
    }

    if (pairDropdown) {
      pairDropdown.classList.toggle(
        'active_dps'
      );
    }
  }
);

function ccIsUpcartActive() {
  /*
   * Most reliable option:
   * Allow the A/B test to explicitly mark the cart variation.
   */
  const explicitCartMode =
    document.documentElement.dataset.ccCartMode ||
    document.body?.dataset.ccCartMode ||
    '';

  if (explicitCartMode === 'upcart') {
    return true;
  }

  if (explicitCartMode === 'broadcast') {
    return false;
  }

  /*
   * Automatic fallback detection.
   * This is checked whenever a cart request completes,
   * not only when the page first loads.
   */
  const upcartElement = document.querySelector(
    [
      '#UpcartPopup',
      '#upcart-cart',
      '.upcart-header',
      '[class*="UpcartDesignSettings"]',
      '[data-upcart]'
    ].join(',')
  );

  const upcartScript = Array.from(
    document.scripts
  ).some(function (script) {
    return /upcart/i.test(script.src || '');
  });

  const upcartGlobal =
    typeof window.Upcart !== 'undefined' ||
    typeof window.upcart !== 'undefined';

  return Boolean(
    upcartElement ||
    upcartScript ||
    upcartGlobal
  );
}

document.addEventListener(
  'click',
  async function (event) {
    const button = event.target.closest(
      '[data-cc-add-to-cart]'
    );

    if (!button) {
      return;
    }

    event.preventDefault();

    const card = button.closest(
      '[data-cc-grid-cart]'
    );

    const variantSelect = card?.querySelector(
      '[data-cc-variant-select]'
    );

    const quantitySelect = card?.querySelector(
      '[data-cc-qty-select]'
    );

    if (
      !card ||
      !variantSelect ||
      !quantitySelect
    ) {
      return;
    }

    const variantId = Number(
      variantSelect.value
    );

    const quantity = Math.max(
      1,
      Number(quantitySelect.value || 1)
    );

    if (
      !Number.isFinite(variantId) ||
      variantId <= 0
    ) {
      return;
    }

    const originalButtonText =
      button.textContent;

    button.disabled = true;
    button.textContent = 'ADDING...';

    try {
      const response = await fetch(
        window.theme?.routes?.cart_add_url ||
          '/cart/add.js',
        {
          method: 'POST',

          headers: {
            'Content-Type':
              'application/json',

            Accept:
              'application/json'
          },

          body: JSON.stringify({
            id: variantId,
            quantity: quantity
          })
        }
      );

      const result = await response.json();

      if (!response.ok || result.status) {
        throw new Error(
          result.description ||
          result.message ||
          'Add to cart failed'
        );
      }

      button.textContent = 'ADDED';

      /*
       * UpCart variant:
       * preserve the events used by the previous working code.
       *
       * Broadcast variant:
       * do nothing here because the global Fetch bridge
       * will refresh the Broadcast cart once.
       */
      if (ccIsUpcartActive()) {
        document.dispatchEvent(
          new CustomEvent('theme:cart:reload', {
            bubbles: true
          })
        );

        document.dispatchEvent(
          new CustomEvent('cart:refresh', {
            bubbles: true
          })
        );
      }
    } catch (error) {
      button.textContent = 'ERROR';
      console.error(
        'Collection add to cart error:',
        error
      );
    }

    setTimeout(function () {
      button.disabled = false;
      button.textContent =
        originalButtonText ||
        'ADD TO CART';
    }, 1200);
  }
);

function ccInitializeCollectionGridItem(
  gridItem
) {
  if (!gridItem) {
    return;
  }

  const firstSwatch =
    gridItem.querySelector(
      '[data-swatch-button]'
    );

  if (
    firstSwatch &&
    !gridItem.querySelector(
      '[data-swatch-button].cc-color-selected'
    )
  ) {
    firstSwatch.classList.add(
      'cc-color-selected'
    );
  }

  gridItem
    .querySelectorAll(
      '[data-cc-grid-cart]'
    )
    .forEach(function (card) {
      if (
        card.dataset
          .ccCollectionInitialized ===
        'true'
      ) {
        return;
      }

      ccCaptureInitialGridPrice(card);

      const quantitySelect =
        card.querySelector(
          '[data-cc-qty-select]'
        );

      const pairLabel =
        card.querySelector(
          '[data-cc-pair-label]'
        );

      const usePairDefault =
        quantitySelect &&
        ccCardDefaultsToPair(card) &&
        !card.dataset.ccManualSelection;

      if (usePairDefault) {
        quantitySelect.value = '2';

        quantitySelect.setAttribute(
          'value',
          '2'
        );

        card.dataset.ccManualSelection =
          'pair';

        if (pairLabel) {
          pairLabel.textContent =
            'Pair';
        }

        card
          .querySelector(
            '.single-button'
          )
          ?.classList.remove(
            'active'
          );

        card
          .querySelector(
            '.pair-button'
          )
          ?.classList.add(
            'active'
          );
      }

      const selectedColor =
        ccGetActiveColorFromCard(
          gridItem
        );

      const visibleVariantDropdown =
        card.querySelector(
          '[data-cc-variant-display-select]'
        );

      const nonColorValue =
        visibleVariantDropdown
          ? visibleVariantDropdown.value
          : null;

      ccSelectVariantByOptions(
        card,
        selectedColor,
        nonColorValue
      );

      ccUpdateGridCardPrice(card);

      card.dataset
        .ccCollectionInitialized =
        'true';
    });
}

function ccInitializeCollectionCards(
  root
) {
  if (
    !(
      root instanceof Element ||
      root === document
    )
  ) {
    return;
  }

  if (
    root.matches?.(
      [
        '[data-grid-item]',
        'grid-item.product-item',
        'grid-item'
      ].join(',')
    )
  ) {
    ccInitializeCollectionGridItem(
      root
    );
  }

  root
    .querySelectorAll?.(
      [
        '[data-grid-item]',
        'grid-item.product-item',
        'grid-item'
      ].join(',')
    )
    .forEach(
      ccInitializeCollectionGridItem
    );
}

document.addEventListener(
  'DOMContentLoaded',
  function () {
    ccInitializeCollectionCards(
      document
    );

    const collectionPage =
      document.querySelector(
        'collection-component'
      );

    if (!collectionPage) {
      return;
    }

    const collectionCardObserver =
      new MutationObserver(
        function (mutations) {
          mutations.forEach(
            function (mutation) {
              mutation.addedNodes.forEach(
                function (node) {
                  if (
                    !(node instanceof Element)
                  ) {
                    return;
                  }

                  ccInitializeCollectionCards(
                    node
                  );
                }
              );
            }
          );
        }
      );

    collectionCardObserver.observe(
      collectionPage,
      {
        childList: true,
        subtree: true
      }
    );
  }
);

/* -------------------------------------------------------------------------- */
/* Wrap PDP ATC and wishlist buttons                                          */
/* -------------------------------------------------------------------------- */

document.addEventListener(
  'DOMContentLoaded',
  function () {
    const addToCartBlock =
      document.querySelector(
        '.product__block--buttons'
      );

    const wishlistButtonContainer =
      document.querySelector(
        '.swym-atw-button-container'
      );

    if (
      !addToCartBlock ||
      !wishlistButtonContainer
    ) {
      return;
    }

    const wishlistBlock =
      wishlistButtonContainer.closest(
        '.shopify-app-block'
      );

    if (!wishlistBlock) {
      return;
    }

    if (
      addToCartBlock.parentNode
        .classList.contains(
          'pdp-buttons-wrapper'
        )
    ) {
      return;
    }

    const wrapper =
      document.createElement('div');

    wrapper.className =
      'pdp-buttons-wrapper';

    addToCartBlock.parentNode
      .insertBefore(
        wrapper,
        addToCartBlock
      );

    wrapper.appendChild(
      addToCartBlock
    );

    wrapper.appendChild(
      wishlistBlock
    );
  }
);

/* -------------------------------------------------------------------------- */
/* PDP pricing A/B changes                                                    */
/* -------------------------------------------------------------------------- */

if (!window.__ccPairPricingLoaded) {
  window.__ccPairPricingLoaded = true;

  window.addEventListener(
    'load',
    function () {
      function formatMoney(number) {
        const numericValue = Number(number);

        if (!Number.isFinite(numericValue)) {
          return '';
        }

        return ccFormatMoney(
          Math.round(numericValue * 100)
        );
      }

      function getNumber(text) {
        const value = String(text || '')
          .replace(/\u00a0/g, ' ')
          .trim();

        if (!value) {
          return null;
        }

        const matches = value.match(
          /-?\d[\d.,\s]*/g
        );

        if (!matches || !matches.length) {
          return null;
        }

        let normalized = matches[
          matches.length - 1
        ]
          .replace(/\s/g, '')
          .replace(/[^0-9.,-]/g, '');

        const lastComma =
          normalized.lastIndexOf(',');

        const lastDot =
          normalized.lastIndexOf('.');

        if (
          lastComma > -1 &&
          lastDot > -1
        ) {
          if (lastComma > lastDot) {
            normalized = normalized
              .replace(/\./g, '')
              .replace(',', '.');
          } else {
            normalized = normalized
              .replace(/,/g, '');
          }
        } else if (lastComma > -1) {
          const decimalDigits =
            normalized.length -
            lastComma -
            1;

          normalized =
            decimalDigits === 2
              ? normalized.replace(',', '.')
              : normalized.replace(/,/g, '');
        } else if (lastDot > -1) {
          const dotCount =
            (normalized.match(/\./g) || [])
              .length;

          if (dotCount > 1) {
            const parts =
              normalized.split('.');

            const decimalPart =
              parts.pop();

            normalized =
              parts.join('') +
              '.' +
              decimalPart;
          }
        }

        const number = Number(normalized);

        return Number.isFinite(number)
          ? number
          : null;
      }

      function setTextIfDifferent(
        element,
        value
      ) {
        if (
          element &&
          element.textContent.trim() !==
            value
        ) {
          element.textContent = value;
        }
      }

      function setHtmlIfDifferent(
        element,
        value
      ) {
        if (!element) {
          return;
        }

        const current =
          element.innerHTML
            .replace(/\s+/g, ' ')
            .trim();

        const next =
          value
            .replace(/\s+/g, ' ')
            .trim();

        if (current !== next) {
          element.innerHTML = value;
        }
      }

      let cachedProductVariants = null;
      let lastVariantSearchTime = 0;

      function getVariantsFromObject(
        object
      ) {
        const possibleVariantLists = [
          object?.variants,
          object?.product?.variants,
          object?.data?.product?.variants
        ];

        return (
          possibleVariantLists.find(
            function (variants) {
              return (
                Array.isArray(variants) &&
                variants.length
              );
            }
          ) || null
        );
      }

      function getProductVariants() {
        if (
          Array.isArray(
            cachedProductVariants
          ) &&
          cachedProductVariants.length
        ) {
          return cachedProductVariants;
        }

        const now = Date.now();

        if (
          now - lastVariantSearchTime <
          1000
        ) {
          return [];
        }

        lastVariantSearchTime = now;

        const possibleProducts = [
          window.meta?.product,
          window.ShopifyAnalytics?.meta
            ?.product,
          window.product,
          window.__product
        ];

        for (
          const product of possibleProducts
        ) {
          const variants =
            getVariantsFromObject(product);

          if (variants) {
            cachedProductVariants =
              variants;

            return cachedProductVariants;
          }
        }

        const jsonScripts =
          document.querySelectorAll(
            'script[type="application/json"]'
          );

        for (const script of jsonScripts) {
          const text =
            script.textContent?.trim();

          if (
            !text ||
            !text.includes('"variants"')
          ) {
            continue;
          }

          try {
            const parsed = JSON.parse(text);

            const variants =
              getVariantsFromObject(parsed);

            if (variants) {
              cachedProductVariants =
                variants;

              return cachedProductVariants;
            }
          } catch (error) {
            // Ignore unrelated JSON.
          }
        }

        return [];
      }

      function getSelectedVariantId(
        productId
      ) {
        const selectors = [
          'form[action*="/cart/add"] input[name="id"][value]',
          'form[action*="/cart/add"] select[name="id"]',
          'input[name="id"].product-variant-id[value]',
          'select[name="id"]'
        ];

        const productScope =
          document.querySelector(
            `[data-product-id="${productId}"]`
          );

        const scopes = [
          productScope,
          document.querySelector('main'),
          document
        ].filter(Boolean);

        for (const scope of scopes) {
          for (const selector of selectors) {
            const controls =
              scope.querySelectorAll(selector);

            for (const control of controls) {
              const value =
                control.value ||
                control.getAttribute('value');

              if (value) {
                return String(value);
              }
            }
          }
        }

        const urlVariant =
          new URLSearchParams(
            window.location.search
          ).get('variant');

        return urlVariant
          ? String(urlVariant)
          : null;
      }

      function getVariantMoneyValue(
        value
      ) {
        if (value == null) {
          return null;
        }

        if (
          typeof value === 'object' &&
          value.amount != null
        ) {
          const amount =
            Number(value.amount);

          return Number.isFinite(amount)
            ? amount
            : null;
        }

        const cents = Number(value);

        return Number.isFinite(cents)
          ? cents / 100
          : null;
      }

      function getSelectedVariantPricing(
        productId
      ) {
        const variants =
          getProductVariants();

        if (!variants.length) {
          return null;
        }

        const selectedVariantId =
          getSelectedVariantId(productId);

        let selectedVariant = null;

        if (selectedVariantId) {
          selectedVariant = variants.find(
            function (variant) {
              return (
                String(variant?.id) ===
                selectedVariantId
              );
            }
          );
        }

        if (
          !selectedVariant &&
          variants.length === 1
        ) {
          selectedVariant = variants[0];
        }

        if (!selectedVariant) {
          return null;
        }

        return {
          id: String(
            selectedVariant.id || ''
          ),

          price: getVariantMoneyValue(
            selectedVariant.price
          ),

          compareAtPrice:
            getVariantMoneyValue(
              selectedVariant
                .compare_at_price ??
              selectedVariant
                .compareAtPrice
            )
        };
      }

      window.ccPdpSelected =
        window.ccPdpSelected ||
        'pair';

      function selectPairButton(
        selector
      ) {
        const pairButton =
          document.querySelector(
            selector
          );

        if (pairButton) {
          pairButton.click();

          window.ccPdpSelected =
            'pair';

          return true;
        }

        return false;
      }

      const pdpDesktopPairInterval =
        setInterval(function () {
          if (
            selectPairButton(
              '.r-ce7u3w'
            )
          ) {
            clearInterval(
              pdpDesktopPairInterval
            );
          }
        }, 300);

      const pdpMobilePairInterval =
        setInterval(function () {
          if (
            selectPairButton(
              '.r-1usadv0'
            )
          ) {
            clearInterval(
              pdpMobilePairInterval
            );
          }
        }, 300);

      setTimeout(function () {
        clearInterval(
          pdpDesktopPairInterval
        );

        clearInterval(
          pdpMobilePairInterval
        );
      }, 6000);

      document.addEventListener(
        'click',
        function (event) {
          if (
            event.target.closest(
              [
                '.r-ce7u3w',
                '.r-1usadv0',
                '[data-pair-button]'
              ].join(',')
            )
          ) {
            window.ccPdpSelected =
              'pair';
          }

          if (
            event.target.closest(
              [
                '.r-1r08zu',
                '.r-1uuskjb',
                '[data-single-btn]',
                "[aria-label='atc-section-1'] [data-replo-price='true']:not([data-pair-button])"
              ].join(',')
            )
          ) {
            window.ccPdpSelected =
              'single';
          }
        }
      );

      function getTrueBasePrice(
        productId,
        pairSpan,
        variantPricing
      ) {
        if (
          variantPricing?.price != null &&
          Number.isFinite(
            variantPricing.price
          )
        ) {
          return variantPricing.price;
        }

        let trueBasePrice =
          getNumber(
            pairSpan?.dataset
              .ccTrueBasePrice
          );

        if (trueBasePrice != null) {
          return trueBasePrice;
        }

        const nonStickySingle =
          document.querySelector(
            `[aria-label="atc-section-2"] [data-single-btn="${productId}"] span`
          );

        if (nonStickySingle) {
          trueBasePrice =
            getNumber(
              nonStickySingle
                .textContent
            );
        }

        if (
          trueBasePrice == null
        ) {
          trueBasePrice =
            getNumber(
              pairSpan?.dataset
                .originalPrice
            );
        }

        if (
          trueBasePrice == null
        ) {
          const pairPrice =
            getNumber(
              pairSpan?.textContent
            );

          trueBasePrice =
            pairPrice == null
              ? null
              : pairPrice / 2;
        }

        return trueBasePrice;
      }

      function getNativeCompareAtPrice(
        productId,
        trueBasePrice
      ) {
        const productScope =
          document.querySelector(
            `[data-product-id="${productId}"]`
          );

        const selectors = [
          '.product__price__wrap s',
          '.product__price__wrap del',
          '.product__price__wrap .price__compare',
          '.product__price .price__sale .price-item--regular',
          '.product__price [data-compare-price]',
          '.product__price [data-compare-at-price]',
          '[data-product-price] s',
          '[data-product-price] del'
        ];

        const scopes = [
          productScope,
          document.querySelector('main'),
          document
        ].filter(Boolean);

        for (const scope of scopes) {
          for (const selector of selectors) {
            const elements =
              scope.querySelectorAll(selector);

            for (const element of elements) {
              const compareAtPrice =
                getNumber(
                  element.textContent
                );

              if (
                compareAtPrice != null &&
                compareAtPrice >
                  trueBasePrice
              ) {
                return compareAtPrice;
              }
            }
          }
        }

        return null;
      }

      function getTrueCompareAtPrice(
        productId,
        pairSpan,
        trueBasePrice,
        variantPricing
      ) {
        const variantCompareAt =
          variantPricing?.compareAtPrice;

        if (
          variantCompareAt != null &&
          Number.isFinite(
            variantCompareAt
          ) &&
          variantCompareAt >
            trueBasePrice
        ) {
          return variantCompareAt;
        }

        const possibleDatasetValues = [
          pairSpan?.dataset
            .ccTrueCompareAtPrice,
          pairSpan?.dataset
            .compareAtPrice,
          pairSpan?.dataset
            .comparePrice
        ];

        for (
          const value of
            possibleDatasetValues
        ) {
          const compareAtPrice =
            getNumber(value);

          if (
            compareAtPrice != null &&
            compareAtPrice >
              trueBasePrice
          ) {
            return compareAtPrice;
          }
        }

        return getNativeCompareAtPrice(
          productId,
          trueBasePrice
        );
      }

      function updatePdpPrices() {
        const pairWrappers =
          document.querySelectorAll(
            'div[data-pair-button]'
          );

        pairWrappers.forEach(
          function (pairWrapper) {
            const pairSpan =
              pairWrapper.querySelector(
                'span'
              );

            if (!pairSpan) {
              return;
            }

            const productId =
              pairWrapper.dataset
                .pairButton;

            if (!productId) {
              return;
            }

            const variantPricing =
              getSelectedVariantPricing(
                productId
              );

            const trueBasePrice =
              getTrueBasePrice(
                productId,
                pairSpan,
                variantPricing
              );

            if (
              trueBasePrice == null ||
              !Number.isFinite(
                trueBasePrice
              )
            ) {
              return;
            }

            const trueCompareAtPrice =
              getTrueCompareAtPrice(
                productId,
                pairSpan,
                trueBasePrice,
                variantPricing
              );

            const regularPairPrice =
              trueBasePrice * 2;

            const pairComparePrice =
              trueCompareAtPrice != null &&
              trueCompareAtPrice >
                trueBasePrice
                ? trueCompareAtPrice * 2
                : regularPairPrice;

            const pairDiscountPrice =
              regularPairPrice * 0.9;

            const discountedHalf =
              (
                pairDiscountPrice / 2
              ).toFixed(2);

            pairSpan.dataset
              .ccTrueBasePrice =
              String(trueBasePrice);

            pairSpan.dataset
              .ccTrueCompareAtPrice =
              String(
                trueCompareAtPrice || 0
              );

            pairSpan.dataset
              .ccVariantId =
              variantPricing?.id || '';

            pairSpan.dataset
              .originalPrice =
              discountedHalf;

            document
              .querySelectorAll(
                `[data-pair-button="${productId}"] span`
              )
              .forEach(
                function (span) {
                  span.dataset
                    .ccTrueBasePrice =
                    String(
                      trueBasePrice
                    );

                  span.dataset
                    .ccTrueCompareAtPrice =
                    String(
                      trueCompareAtPrice ||
                      0
                    );

                  span.dataset
                    .ccVariantId =
                    variantPricing?.id || '';

                  span.dataset
                    .originalPrice =
                    discountedHalf;

                  setTextIfDifferent(
                    span,
                    formatMoney(
                      pairDiscountPrice
                    )
                  );
                }
              );

            document
              .querySelectorAll(
                `[data-single-btn="${productId}"] span`
              )
              .forEach(
                function (
                  singleSpan
                ) {
                  setTextIfDifferent(
                    singleSpan,
                    formatMoney(
                      trueBasePrice
                    )
                  );
                }
              );

            document
              .querySelectorAll(
                `[data-product-id="${productId}"][data-replo-price="true"] span`
              )
              .forEach(
                function (
                  singleSpan
                ) {
                  const wrapper =
                    singleSpan.closest(
                      '[data-replo-price="true"]'
                    );

                  if (
                    !wrapper ||
                    wrapper.hasAttribute(
                      'data-pair-button'
                    )
                  ) {
                    return;
                  }

                  setTextIfDifferent(
                    singleSpan,
                    formatMoney(
                      trueBasePrice
                    )
                  );
                }
              );

            const mainPriceElements =
              document.querySelectorAll(
                [
                  '.r-7fj8r5',
                  '.r-gkaie6',
                  '.r-kq20sf'
                ].join(',')
              );

            mainPriceElements.forEach(
              function (
                priceElement
              ) {
                if (
                  window
                    .ccPdpSelected ===
                  'pair'
                ) {
                  setHtmlIfDifferent(
                    priceElement,
                    `
                      <span style="text-decoration: line-through; opacity: 0.7; margin-right: 8px;">
                        ${formatMoney(
                          pairComparePrice
                        )}
                      </span>

                      <span>
                        ${formatMoney(
                          pairDiscountPrice
                        )}
                      </span>
                    `
                  );
                } else if (
                  trueCompareAtPrice != null &&
                  trueCompareAtPrice >
                    trueBasePrice
                ) {
                  setHtmlIfDifferent(
                    priceElement,
                    `
                      <span style="text-decoration: line-through; opacity: 0.7; margin-right: 8px;">
                        ${formatMoney(
                          trueCompareAtPrice
                        )}
                      </span>

                      <span>
                        ${formatMoney(
                          trueBasePrice
                        )}
                      </span>
                    `
                  );
                } else {
                  setHtmlIfDifferent(
                    priceElement,
                    `<span>${formatMoney(
                      trueBasePrice
                    )}</span>`
                  );
                }
              }
            );
          }
        );
      }

      function clearPdpPriceCache() {
        cachedProductVariants = null;
        lastVariantSearchTime = 0;

        document
          .querySelectorAll(
            '[data-pair-button] span'
          )
          .forEach(function (span) {
            delete span.dataset
              .ccTrueBasePrice;

            delete span.dataset
              .ccTrueCompareAtPrice;

            delete span.dataset
              .ccVariantId;
          });
      }

      document.addEventListener(
        'change',
        function (event) {
          const target = event.target;

          if (
            !(target instanceof Element) ||
            !target.matches(
              [
                '.swatch-input__input',
                '[data-product-option]',
                'select[name^="options"]',
                'input[name^="options"]',
                'input[name="id"]',
                'select[name="id"]'
              ].join(',')
            )
          ) {
            return;
          }

          [
            0,
            100,
            300
          ].forEach(function (delay) {
            setTimeout(function () {
              clearPdpPriceCache();
              updatePdpPrices();
            }, delay);
          });
        }
      );

      [
        'variant:change',
        'variant:changed',
        'product:variant-change'
      ].forEach(function (eventName) {
        document.addEventListener(
          eventName,
          function () {
            clearPdpPriceCache();

            setTimeout(
              updatePdpPrices,
              50
            );
          }
        );
      });

      updatePdpPrices();

      setInterval(
        updatePdpPrices,
        150
      );
    }
  );
}

/* -------------------------------------------------------------------------- */
/* Wishlist icon on infinite-scroll products                                  */
/* -------------------------------------------------------------------------- */

document.addEventListener(
  'DOMContentLoaded',
  function () {
    const collectionPage =
      document.querySelector(
        'collection-component'
      );

    if (!collectionPage) {
      return;
    }

    const initSwymObserver =
      function () {
        const grid =
          collectionPage.querySelector(
            [
              '[data-collection-products]',
              '[data-products-grid]',
              '[data-grid]',
              '.collection__products'
            ].join(',')
          );

        if (!grid) {
          return;
        }

        let timer;
        let lastRun = 0;

        const observer =
          new MutationObserver(
            function (mutations) {
              const hasNewProductCard =
                mutations.some(
                  function (mutation) {
                    return Array.from(
                      mutation.addedNodes
                    ).some(
                      function (node) {
                        return (
                          node.nodeType ===
                            1 &&
                          (
                            node.matches?.(
                              [
                                'product-item',
                                'grid-item',
                                '[data-grid-item]'
                              ].join(',')
                            ) ||
                            node.querySelector?.(
                              [
                                'product-item',
                                'grid-item',
                                '[data-grid-item]'
                              ].join(',')
                            )
                          )
                        );
                      }
                    );
                  }
                );

              if (!hasNewProductCard) {
                return;
              }

              clearTimeout(timer);

              timer = setTimeout(
                function () {
                  const now =
                    Date.now();

                  if (
                    now - lastRun <
                    1500
                  ) {
                    return;
                  }

                  lastRun = now;

                  document.dispatchEvent(
                    new CustomEvent(
                      'swym:collections-loaded'
                    )
                  );
                },
                700
              );
            }
          );

        observer.observe(grid, {
          childList: true,
          subtree: true
        });
      };

    if (
      'requestIdleCallback' in
      window
    ) {
      window.requestIdleCallback(
        initSwymObserver
      );
    } else {
      setTimeout(
        initSwymObserver,
        1500
      );
    }
  }
);

/* -------------------------------------------------------------------------- */
/* Intercom position                                                          */
/* -------------------------------------------------------------------------- */

(function () {
  'use strict';

  var CONFIG = {
    alignment: 'right',
    horizontal_padding: 24,
    vertical_padding: 100,
    bottom: '100px',
    right: '12px'
  };

  var SELECTORS = [
    '.intercom-lightweight-app',
    '.intercom-lightweight-app-launcher',
    'iframe#intercom-launcher-frame'
  ].join(', ');

  window.intercomSettings = Object.assign(
    window.intercomSettings || {},
    {
      alignment: CONFIG.alignment,
      horizontal_padding: CONFIG.horizontal_padding,
      vertical_padding: CONFIG.vertical_padding
    }
  );

  if (!document.getElementById('cc-intercom-position')) {
    var style = document.createElement('style');

    style.id = 'cc-intercom-position';

    style.textContent =
      SELECTORS +
      '{' +
      'bottom:' + CONFIG.bottom + '!important;' +
      'right:' + CONFIG.right + '!important;' +
      'left:auto!important;' +
      '}';

    document.head.appendChild(style);
  }

  function updateViaApi() {
    if (typeof window.Intercom !== 'function') {
      return false;
    }

    window.Intercom('update', {
      alignment: CONFIG.alignment,
      horizontal_padding: CONFIG.horizontal_padding,
      vertical_padding: CONFIG.vertical_padding
    });

    return true;
  }

  var attempts = 0;
  var maxAttempts = 20;

  var bootPoll = setInterval(function () {
    attempts += 1;

    if (updateViaApi() || attempts >= maxAttempts) {
      clearInterval(bootPoll);
    }
  }, 500);

  window.addEventListener('load', updateViaApi);

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) {
      updateViaApi();
    }
  });
})();

/* -------------------------------------------------------------------------- */
/* Hide houseplant bundle price                                               */
/* -------------------------------------------------------------------------- */

(function () {
  const PRODUCT_HANDLE =
    'houseplant-flat-back-bundle';

  function hideBundlePrice() {
    if (
      window.location.pathname.includes(
        `/products/${PRODUCT_HANDLE}`
      )
    ) {
      document
        .querySelectorAll(
          '.product__price__wrap'
        )
        .forEach(
          function (element) {
            element.style.display =
              'none';
          }
        );
    }

    document
      .querySelectorAll(
        `a[href*="/products/${PRODUCT_HANDLE}"]`
      )
      .forEach(function (link) {
        const card =
          link.closest(
            'grid-item'
          );

        if (!card) {
          return;
        }

        card
          .querySelectorAll(
            '.product-variant-and-price'
          )
          .forEach(
            function (element) {
              element.style.display =
                'none';
            }
          );
      });
  }

  hideBundlePrice();

  new MutationObserver(
    hideBundlePrice
  ).observe(
    document.body,
    {
      childList: true,
      subtree: true
    }
  );
})();

/* -------------------------------------------------------------------------- */
/* Single/Pair quick-view modal                                               */
/* -------------------------------------------------------------------------- */

(function () {
  if (
    window
      .__apiPairDropdownLoaded
  ) {
    return;
  }

  window.__apiPairDropdownLoaded =
    true;

  function getProductForm(
    dropdown
  ) {
    const formId =
      dropdown?.dataset
        .productFormId;

    if (!formId) {
      return null;
    }

    return document.getElementById(
      formId
    );
  }

  function getSelectedVariantId(
    dropdown
  ) {
    const productForm =
      getProductForm(
        dropdown
      );

    if (!productForm) {
      return null;
    }

    const variantInput =
      productForm.querySelector(
        [
          'input[name="id"].product-variant-id',
          'input[name="id"]'
        ].join(',')
      );

    return (
      variantInput?.value ||
      null
    );
  }

  function refreshVariantPrices(
    dropdown
  ) {
    const variantId =
      getSelectedVariantId(
        dropdown
      );

    if (!variantId) {
      return;
    }

    const variantPrice =
      dropdown.querySelector(
        `[data-pair-variant-price][data-variant-id="${variantId}"]`
      );

    if (!variantPrice) {
      return;
    }

    dropdown.dataset.singlePrice =
      variantPrice.dataset
        .singlePrice;

    dropdown.dataset
      .pairComparePrice =
      variantPrice.dataset
        .pairComparePrice;

    dropdown.dataset
      .pairDiscountPrice =
      variantPrice.dataset
        .pairDiscountPrice;

    const singleRadio =
      dropdown.querySelector(
        '[data-pair-radio][value="1"]'
      );

    const pairRadio =
      dropdown.querySelector(
        '[data-pair-radio][value="2"]'
      );

    const singleOptionPrice =
      singleRadio
        ?.closest(
          '.api-pair-option'
        )
        ?.querySelector(
          '[data-pair-option-price]'
        );

    const pairOptionPrice =
      pairRadio
        ?.closest(
          '.api-pair-option'
        )
        ?.querySelector(
          '[data-pair-option-price]'
        );

    if (singleOptionPrice) {
      singleOptionPrice.textContent =
        variantPrice.dataset
          .singlePrice;
    }

    if (pairOptionPrice) {
      pairOptionPrice.innerHTML = `
        <s>
          ${variantPrice.dataset.pairComparePrice}
        </s>

        ${variantPrice.dataset.pairDiscountPrice}
      `;
    }
  }

  function updateQuantity(
    dropdown,
    quantity
  ) {
    const productForm =
      getProductForm(
        dropdown
      );

    if (!productForm) {
      return;
    }

    const quantityInput =
      productForm.querySelector(
        'input[name="quantity"]:not([type="radio"])'
      );

    if (!quantityInput) {
      console.warn(
        'Quick-add quantity input was not found:',
        dropdown.dataset
          .productFormId
      );

      return;
    }

    const nextQuantity =
      String(quantity);

    quantityInput.value =
      nextQuantity;

    quantityInput.setAttribute(
      'value',
      nextQuantity
    );
  }

  function updateMainPrice(
    dropdown,
    selection
  ) {
    const productInfo =
      dropdown.closest(
        'product-info'
      );

    if (!productInfo) {
      return;
    }

    const priceElement =
      productInfo.querySelector(
        [
          '.product__price .price__sale .price-item--sale',
          '.product__price .price__regular .price-item--regular'
        ].join(',')
      );

    if (!priceElement) {
      return;
    }

    const singlePrice =
      dropdown.dataset.singlePrice;

    const pairComparePrice =
      dropdown.dataset
        .pairComparePrice;

    const pairDiscountPrice =
      dropdown.dataset
        .pairDiscountPrice;

    if (selection === 'pair') {
      priceElement.innerHTML = `
        <s class="api-pair-compare-price">
          ${pairComparePrice}
        </s>

        <span class="api-pair-discount-price">
          ${pairDiscountPrice}
        </span>
      `;
    } else {
      priceElement.innerHTML = `
        <span>
          ${singlePrice}
        </span>
      `;
    }
  }

  function updateSelectedStyle(
    dropdown,
    selectedRadio
  ) {
    dropdown
      .querySelectorAll(
        '.api-pair-option'
      )
      .forEach(
        function (option) {
          const optionRadio =
            option.querySelector(
              '[data-pair-radio]'
            );

          option.classList.toggle(
            'is-selected',
            optionRadio ===
              selectedRadio
          );
        }
      );
  }

  function applySelection(
    dropdown,
    radio
  ) {
    if (!dropdown || !radio) {
      return;
    }

    refreshVariantPrices(
      dropdown
    );

    const quantity =
      Number(radio.value) || 1;

    const selection =
      quantity === 2
        ? 'pair'
        : 'single';

    updateQuantity(
      dropdown,
      quantity
    );

    updateMainPrice(
      dropdown,
      selection
    );

    updateSelectedStyle(
      dropdown,
      radio
    );

    const summary =
      dropdown.querySelector(
        '[data-pair-summary]'
      );

    if (summary) {
      summary.textContent =
        radio.dataset.label ||
        'Single';
    }
  }

  function reapplyCurrentSelection(
    productInfo
  ) {
    if (
      !productInfo?.isConnected
    ) {
      return;
    }

    const dropdown =
      productInfo.querySelector(
        '[data-pair-dropdown]'
      );

    if (!dropdown) {
      return;
    }

    const selectedRadio =
      dropdown.querySelector(
        '[data-pair-radio]:checked'
      );

    if (!selectedRadio) {
      return;
    }

    applySelection(
      dropdown,
      selectedRadio
    );
  }

  function scheduleVariantPriceUpdate(
    productInfo
  ) {
    [
      50,
      150,
      350,
      600
    ].forEach(
      function (delay) {
        setTimeout(
          function () {
            reapplyCurrentSelection(
              productInfo
            );
          },
          delay
        );
      }
    );
  }

  function initializePairDropdown(
    dropdown
  ) {
    if (!dropdown) {
      return;
    }

    if (
      dropdown.dataset
        .pairInitialized ===
      'true'
    ) {
      return;
    }

    const pairRadio =
      dropdown.querySelector(
        '[data-pair-radio][value="2"]'
      );

    if (!pairRadio) {
      return;
    }

    dropdown.dataset
      .pairInitialized =
      'true';

    pairRadio.checked = true;

    requestAnimationFrame(
      function () {
        applySelection(
          dropdown,
          pairRadio
        );
      }
    );

    setTimeout(
      function () {
        applySelection(
          dropdown,
          pairRadio
        );
      },
      100
    );
  }

  function initializeAllPairDropdowns(
    root
  ) {
    const scope =
      root || document;

    if (
      scope.matches?.(
        '[data-pair-dropdown]'
      )
    ) {
      initializePairDropdown(
        scope
      );
    }

    scope
      .querySelectorAll?.(
        '[data-pair-dropdown]'
      )
      .forEach(
        initializePairDropdown
      );
  }

  document.addEventListener(
    'change',
    function (event) {
      const radio =
        event.target.closest(
          '[data-pair-radio]'
        );

      if (!radio) {
        return;
      }

      const dropdown =
        radio.closest(
          '[data-pair-dropdown]'
        );

      if (!dropdown) {
        return;
      }

      applySelection(
        dropdown,
        radio
      );

      dropdown.removeAttribute(
        'open'
      );
    }
  );

  document.addEventListener(
    'change',
    function (event) {
      const target =
        event.target;

      if (
        !(target instanceof Element)
      ) {
        return;
      }

      const isVariantControl =
        target.matches(
          [
            '.swatch-input__input',
            '[data-product-option]',
            'select[name^="options"]',
            'input[name^="options"]',
            'input[name^="Color-"]',
            'input[name^="Colour-"]'
          ].join(',')
        );

      if (!isVariantControl) {
        return;
      }

      const productInfo =
        target.closest(
          'product-info'
        );

      if (!productInfo) {
        return;
      }

      if (
        !productInfo.querySelector(
          '[data-pair-dropdown]'
        )
      ) {
        return;
      }

      scheduleVariantPriceUpdate(
        productInfo
      );
    }
  );

  [
    'variant:change',
    'variant:changed',
    'product:variant-change'
  ].forEach(
    function (eventName) {
      document.addEventListener(
        eventName,
        function (event) {
          const eventTarget =
            event.target;

          if (
            !(
              eventTarget instanceof
              Element
            )
          ) {
            return;
          }

          const productInfo =
            eventTarget.closest(
              'product-info'
            );

          if (!productInfo) {
            return;
          }

          if (
            !productInfo.querySelector(
              '[data-pair-dropdown]'
            )
          ) {
            return;
          }

          scheduleVariantPriceUpdate(
            productInfo
          );
        }
      );
    }
  );

  initializeAllPairDropdowns(
    document
  );

  const observer =
    new MutationObserver(
      function (mutations) {
        mutations.forEach(
          function (mutation) {
            mutation.addedNodes.forEach(
              function (node) {
                if (
                  node.nodeType !==
                  Node.ELEMENT_NODE
                ) {
                  return;
                }

                initializeAllPairDropdowns(
                  node
                );
              }
            );
          }
        );
      }
    );

  observer.observe(
    document.body,
    {
      childList: true,
      subtree: true
    }
  );
})();

(function () {
  const WRAPPER_CLASS = 'gfgProgressGiftWrapperV4';

  function wrapProgressAndGift() {
    const progressBar = document.querySelector(
      '.gfgConsolidatedProgressBarSideCartWrapperV4'
    );

    const freeGift = document.querySelector(
      '.gfgFreeGiftSideCartWrapperV4'
    );

    if (!progressBar || !freeGift) return;

    // Already correctly wrapped
    const existingWrapper = progressBar.closest(`.${WRAPPER_CLASS}`);

    if (existingWrapper) {
      if (freeGift.parentElement !== existingWrapper) {
        existingWrapper.appendChild(freeGift);
      }

      return;
    }

    // Remove the old wrapper created by the previous code
    const oldWrapper = progressBar.closest(
      '.gfgShippingProgressWrapperV4'
    );

    if (oldWrapper) {
      oldWrapper.parentNode.insertBefore(progressBar, oldWrapper);
      oldWrapper.remove();
    }

    const parent = progressBar.parentElement;

    if (!parent) return;

    const wrapper = document.createElement('div');

    wrapper.className = WRAPPER_CLASS;

    parent.insertBefore(wrapper, progressBar);

    wrapper.appendChild(progressBar);
    wrapper.appendChild(freeGift);
  }

  wrapProgressAndGift();

  const observer = new MutationObserver(function () {
    wrapProgressAndGift();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();

/* Cart: Make a Flat Back Stud item a pair */
(function initCCCartMakePair() {
  // Prevent this listener from being registered more than once
  if (window.ccCartMakePairInitialized) {
    return;
  }

  window.ccCartMakePairInitialized = true;

  document.addEventListener('click', function (event) {
    const pairButton = event.target.closest(
      '[data-cc-cart-make-pair]'
    );

    if (!pairButton) {
      return;
    }

    event.preventDefault();

    const cartItem = pairButton.closest('[data-item]');

    const quantityInput = cartItem?.querySelector(
      'quantity-input input[name="updates[]"]'
    );

    if (!quantityInput || quantityInput.disabled) {
      return;
    }

    const currentQuantity =
      parseInt(quantityInput.value, 10) || 0;

    // Safety check in case the cart has already been updated
    if (currentQuantity >= 2) {
      pairButton.remove();
      return;
    }

    // Prevent repeated clicks while the cart is updating
    pairButton.disabled = true;

    // Set the exact cart line quantity to 2
    quantityInput.value = '2';

    // Trigger the Broadcast theme's native cart update system
    quantityInput.dispatchEvent(
      new Event('change', {
        bubbles: true
      })
    );
  });
})();

/* -------------------------------------------------------------------------- */
/* Replo + GemPages: refresh Broadcast cart drawer after third-party ATC       */
/* -------------------------------------------------------------------------- */

(function initCCThirdPartyCartBridge() {
  if (window.__ccThirdPartyCartBridgeInitialized) {
    return;
  }

  window.__ccThirdPartyCartBridgeInitialized = true;

  let nativeThemeAddInProgress = false;
  let nativeThemeAddResetTimer = null;
  let cartRefreshTimer = null;

  /**
   * Check whether a request is being made to Shopify's
   * AJAX add-to-cart endpoint.
   */
  function ccIsCartAddRequest(input) {
    let requestUrl = '';

    if (typeof input === 'string') {
      requestUrl = input;
    } else if (
      typeof Request !== 'undefined' &&
      input instanceof Request
    ) {
      requestUrl = input.url;
    } else if (
      input &&
      typeof input.url === 'string'
    ) {
      requestUrl = input.url;
    }

    if (!requestUrl) {
      return false;
    }

    try {
      const parsedUrl = new URL(
        requestUrl,
        window.location.origin
      );

      return (
        parsedUrl.origin === window.location.origin &&
        /\/cart\/add(?:\.js)?\/?$/.test(
          parsedUrl.pathname
        )
      );
    } catch (error) {
      return false;
    }
  }

  /**
   * Trigger Broadcast's native cart refresh.
   *
   * Broadcast will:
   * - Fetch the updated cart section
   * - Rebuild the cart drawer
   * - Update the cart count
   * - Update totals and discounts
   * - Open the drawer
   */
  function ccRefreshBroadcastCart() {
    /*
     * UpCart is controlling the cart in this variation.
     * Never start Broadcast's drawer lifecycle.
     */
    if (ccIsUpcartActive()) {
      return;
    }

    clearTimeout(cartRefreshTimer);

    cartRefreshTimer = setTimeout(function () {
      const cartItems =
        document.querySelector('cart-items');

      if (!cartItems) {
        return;
      }

      document.dispatchEvent(
        new CustomEvent(
          'theme:cart:refresh',
          {
            bubbles: true
          }
        )
      );
    }, 80);
  }

  /**
   * Broadcast's native product-form already handles its
   * own cart refresh. Mark those requests so the bridge
   * does not trigger a duplicate refresh.
   */
  document.addEventListener(
    'theme:cart:add',
    function () {
      nativeThemeAddInProgress = true;

      clearTimeout(nativeThemeAddResetTimer);

      nativeThemeAddResetTimer = setTimeout(
        function () {
          nativeThemeAddInProgress = false;
        },
        4000
      );
    }
  );

  /* ------------------------------- Fetch API ------------------------------- */

  const originalFetch = window.fetch.bind(window);

  window.fetch = async function (input, options) {
    const isCartAddRequest =
      ccIsCartAddRequest(input);

    const isNativeThemeRequest =
      isCartAddRequest &&
      nativeThemeAddInProgress;

    const response = await originalFetch(
      input,
      options
    );

    if (
      isCartAddRequest &&
      response.ok
    ) {
      if (isNativeThemeRequest) {
        nativeThemeAddInProgress = false;
        clearTimeout(nativeThemeAddResetTimer);
      } else {
        ccRefreshBroadcastCart();
      }
    }

    return response;
  };

  /* --------------------------- XMLHttpRequest API -------------------------- */

  const originalXhrOpen =
    XMLHttpRequest.prototype.open;

  const originalXhrSend =
    XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (
    method,
    url
  ) {
    this.__ccIsCartAddRequest =
      ccIsCartAddRequest(url);

    this.__ccIsNativeThemeRequest =
      this.__ccIsCartAddRequest &&
      nativeThemeAddInProgress;

    return originalXhrOpen.apply(
      this,
      arguments
    );
  };

  XMLHttpRequest.prototype.send = function () {
    if (this.__ccIsCartAddRequest) {
      this.addEventListener(
        'load',
        function () {
          const successful =
            this.status >= 200 &&
            this.status < 300;

          if (!successful) {
            return;
          }

          if (this.__ccIsNativeThemeRequest) {
            nativeThemeAddInProgress = false;
            clearTimeout(
              nativeThemeAddResetTimer
            );
          } else {
            ccRefreshBroadcastCart();
          }
        },
        {
          once: true
        }
      );
    }

    return originalXhrSend.apply(
      this,
      arguments
    );
  };
})();

/* -------------------------------------------------------------------------- */
/* Cart pair offer tracking                                                    */
/* -------------------------------------------------------------------------- */

(function initCCCartPairTracking() {
  if (window.__ccCartPairTrackingInitialized) {
    return;
  }

  window.__ccCartPairTrackingInitialized = true;

  const viewedOffers = new Set();

  let pendingApplication = null;
  let pendingTimeout = null;

  /**
   * Build a consistent analytics payload from the button.
   */
  function getPairOfferData(button) {
    return {
      offer_id:
        button.dataset.offerId ||
        'cart_pair_save_10',

      source: button.closest('cart-drawer')
        ? 'cart_drawer'
        : 'cart_page',

      product_id:
        button.dataset.productId || '',

      variant_id:
        button.dataset.variantId || '',

      product_title:
        button.dataset.productTitle || '',

      variant_title:
        button.dataset.variantTitle || '',

      line_key:
        button.dataset.lineKey || '',

      current_quantity: Number(
        button.dataset.currentQuantity || 1
      ),

      target_quantity: 2,

      discount_percent: 10,

      unit_price_cents: Number(
        button.dataset.unitPriceCents || 0
      ),

      currency:
        button.dataset.currency || ''
    };
  }

  /**
   * Publish pair tracking events to:
   * 1. The existing page-level GTM container
   * 2. Shopify Customer Events
   */
  function publishPairEvent(eventName, eventData) {
    const gtmEventNames = {
      'cordsclub:cart_pair_offer_viewed':
        'cc_cart_pair_offer_viewed',

      'cordsclub:cart_pair_offer_clicked':
        'cc_cart_pair_offer_clicked',

      'cordsclub:cart_pair_offer_applied':
        'cc_cart_pair_offer_applied'
    };

    const gtmEventName =
      gtmEventNames[eventName];

    /* ------------------------------------------------ */
    /* GTM                                               */
    /* ------------------------------------------------ */

    if (gtmEventName) {
      window.dataLayer =
        window.dataLayer || [];

      window.dataLayer.push({
        event: gtmEventName,

        offer_id:
          eventData.offer_id ||
          'cart_pair_save_10',

        offer_source:
          eventData.source || '',

        product_id:
          String(
            eventData.product_id || ''
          ),

        variant_id:
          String(
            eventData.variant_id || ''
          ),

        unit_price:
          Number(
            eventData.unit_price_cents || 0
          ) / 100
      });
    }

    /* ------------------------------------------------ */
    /* Shopify Customer Events                          */
    /* ------------------------------------------------ */

    const publish =
      window.Shopify?.analytics?.publish;

    if (typeof publish !== 'function') {
      return;
    }

    try {
      const result = publish(
        eventName,
        eventData
      );

      if (
        result &&
        typeof result.catch === 'function'
      ) {
        result.catch(function (error) {
          console.warn(
            'Pair tracking event failed:',
            eventName,
            error
          );
        });
      }
    } catch (error) {
      console.warn(
        'Pair tracking event failed:',
        eventName,
        error
      );
    }
  }

  /**
   * Determine whether the offer is currently displayed.
   */
  function isOfferDisplayed(button) {
    const cartDrawer =
      button.closest('cart-drawer');

    if (cartDrawer) {
      return cartDrawer.classList.contains(
        'is-open'
      );
    }

    return button.getClientRects().length > 0;
  }

  /**
   * Track each offer view once per cart line per page load.
   */
  function trackVisiblePairOffers() {
    document
      .querySelectorAll(
        '[data-cc-cart-make-pair]'
      )
      .forEach(function (button) {
        if (!isOfferDisplayed(button)) {
          return;
        }

        const eventData =
          getPairOfferData(button);

        const viewKey = [
          eventData.offer_id,
          eventData.line_key
        ].join(':');

        if (
          !eventData.line_key ||
          viewedOffers.has(viewKey)
        ) {
          return;
        }

        viewedOffers.add(viewKey);

        publishPairEvent(
          'cordsclub:cart_pair_offer_viewed',
          eventData
        );
      });
  }

  /**
   * Track the click and remember which cart line
   * should be verified after the cart refreshes.
   */
  document.addEventListener(
    'click',
    function (event) {
      const target =
        event.target instanceof Element
          ? event.target
          : null;

      const button = target?.closest(
        '[data-cc-cart-make-pair]'
      );

      if (!button) {
        return;
      }

      const eventData =
        getPairOfferData(button);

      publishPairEvent(
        'cordsclub:cart_pair_offer_clicked',
        eventData
      );

      pendingApplication = eventData;

      clearTimeout(pendingTimeout);

      /*
       * Do not leave stale pending data if Shopify
       * rejects or fails to process the update.
       */
      pendingTimeout = setTimeout(
        function () {
          pendingApplication = null;
        },
        10000
      );
    }
  );

  /**
   * Broadcast dispatches theme:cart:change after
   * successfully rebuilding the updated cart.
   */
  document.addEventListener(
    'theme:cart:change',
    function () {
      requestAnimationFrame(function () {
        trackVisiblePairOffers();

        if (!pendingApplication) {
          return;
        }

        const quantityInput = Array.from(
          document.querySelectorAll(
            'input[name="updates[]"][data-id]'
          )
        ).find(function (input) {
          return (
            input.dataset.id ===
            pendingApplication.line_key
          );
        });

        /*
         * Only count the application as successful
         * when the refreshed cart confirms quantity 2+.
         */
        if (
          !quantityInput ||
          Number(quantityInput.value) < 2
        ) {
          return;
        }

        publishPairEvent(
          'cordsclub:cart_pair_offer_applied',
          {
            ...pendingApplication,

            final_quantity: Number(
              quantityInput.value
            )
          }
        );

        pendingApplication = null;

        clearTimeout(pendingTimeout);
      });
    }
  );

  /**
   * Track offers when the drawer is opened.
   */
  document.addEventListener(
    'theme:cart-drawer:open',
    function () {
      requestAnimationFrame(
        trackVisiblePairOffers
      );
    }
  );

  /**
   * This covers a normal full cart page.
   */
  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        requestAnimationFrame(
          trackVisiblePairOffers
        );
      }
    );
  } else {
    requestAnimationFrame(
      trackVisiblePairOffers
    );
  }
})();

/* -------------------------------------------------------------------------- */
/* Charm product Single/Pair selector                                         */
/* -------------------------------------------------------------------------- */

(function () {
  if (customElements.get('charm-purchase-options')) {
    return;
  }

  class CharmPurchaseOptions extends HTMLElement {
    constructor() {
      super();

      this.handleChange =
        this.handleChange.bind(this);

      this.handleVariantChange =
        this.handleVariantChange.bind(this);

      this.handleFormSubmit =
        this.handleFormSubmit.bind(this);
    }

    connectedCallback() {
      this.singleInput = this.querySelector(
        '[data-charm-purchase-option][value="1"]'
      );

      this.pairInput = this.querySelector(
        '[data-charm-purchase-option][value="2"]'
      );

      this.refreshFormBindings();
      this.setInitialVariantPrice();

      /*
       * Read the product handle from the Liquid
       * data attribute, with the PDP URL as fallback.
       */
      const productHandleFromUrl =
        window.location.pathname.match(
          /\/products\/([^/?#]+)/
        )?.[1] || '';

      const productHandle = String(
        this.dataset.productHandle ||
          productHandleFromUrl
      )
        .trim()
        .toLowerCase();

      /*
       * Exclusion only controls the default selection.
       * It does not disable the visual Pair discount.
       */
      const pairIsExcluded =
        CC_EXCLUDED_CHARM_PAIR_HANDLES.includes(
          productHandle
        );

      if (
        this.pairInput &&
        !this.pairInput.disabled &&
        !pairIsExcluded
      ) {
        this.pairInput.checked = true;
      } else if (this.singleInput) {
        this.singleInput.checked = true;
      }

      this.addEventListener(
        'change',
        this.handleChange
      );

      if (
        typeof window.subscribe === 'function' &&
        window.theme?.PUB_SUB_EVENTS?.variantChange
      ) {
        this.variantChangeUnsubscriber =
          window.subscribe(
            window.theme.PUB_SUB_EVENTS.variantChange,
            this.handleVariantChange
          );
      }

      this.applySelection();
    }

    disconnectedCallback() {
      this.removeEventListener(
        'change',
        this.handleChange
      );

      this.productForm?.removeEventListener(
        'submit',
        this.handleFormSubmit,
        true
      );

      this.variantChangeUnsubscriber?.();
    }

    refreshFormBindings() {
      const nextProductForm =
        document.getElementById(
          this.dataset.productFormId
        );

      if (nextProductForm !== this.productForm) {
        this.productForm?.removeEventListener(
          'submit',
          this.handleFormSubmit,
          true
        );

        this.productForm = nextProductForm;

        this.productForm?.addEventListener(
          'submit',
          this.handleFormSubmit,
          true
        );
      }

      this.quantityInput =
        this.productForm?.querySelector(
          '[data-charm-quantity-input]'
        );
    }

    setInitialVariantPrice() {
      const productInfo =
        this.closest('product-info');

      const selectedVariantJson =
        productInfo?.querySelector(
          'variant-selects [data-selected-variant]'
        )?.textContent;

      if (!selectedVariantJson) {
        return;
      }

      try {
        const selectedVariant =
          JSON.parse(selectedVariantJson);

        this.setVariantPrice(
          selectedVariant?.price
        );
      } catch (error) {
        console.warn(
          'Charm variant price could not be read.',
          error
        );
      }
    }

    setVariantPrice(price) {
      const priceInCents = Number(price);

      if (Number.isFinite(priceInCents)) {
        this.singlePriceInCents =
          priceInCents;
      }
    }

    handleChange(event) {
      if (
        !event.target.matches(
          '[data-charm-purchase-option]'
        )
      ) {
        return;
      }

      this.applySelection();
    }

    handleFormSubmit() {
      /*
       * Runs before the theme creates FormData.
       * This guarantees Pair submits quantity 2.
       */
      this.applySelection();
    }

    handleVariantChange(payload) {
      const data = payload?.data;
      const productInfo =
        this.closest('product-info');

      const matchingSectionIds = [
        this.dataset.sectionId,
        productInfo?.dataset.section,
        productInfo?.dataset.originalSection
      ]
        .filter(Boolean)
        .map(String);

      if (
        !data ||
        !matchingSectionIds.includes(
          String(data.sectionId)
        )
      ) {
        return;
      }

      const nextOptions =
        data.html?.querySelector(
          `[data-charm-purchase-options][data-section-id="${CSS.escape(
            String(this.dataset.sectionId)
          )}"]`
        ) ||
        data.html?.querySelector(
          '[data-charm-purchase-options]'
        );

      /*
       * Update Pair availability for the newly
       * selected Gold/Silver/Size variant.
       */
      if (nextOptions) {
        const pairAvailable =
          nextOptions.dataset.pairAvailable === 'true';

        this.dataset.pairAvailable =
          String(pairAvailable);

        if (this.pairInput) {
          this.pairInput.disabled =
            !pairAvailable;
        }

        if (
          !pairAvailable &&
          this.pairInput?.checked &&
          this.singleInput
        ) {
          this.singleInput.checked = true;
        }
      }

      /*
       * Store the new variant's single-unit price.
       */
      this.setVariantPrice(
        data.variant?.price
      );

      /*
       * Reapply Pair after the theme resets
       * the quantity during a variant change.
       */
      this.applySelection();

      requestAnimationFrame(() => {
        this.applySelection();
      });
    }

    applySelection() {
      /*
       * Find the form/input again because the
       * theme can refresh them after variants change.
       */
      this.refreshFormBindings();

      if (!this.quantityInput) {
        return;
      }

      const selectedInput =
        this.querySelector(
          '[data-charm-purchase-option]:checked'
        ) || this.singleInput;

      const quantity =
        selectedInput?.value === '2'
          ? '2'
          : '1';

      this.quantityInput.value = quantity;

      this.quantityInput.setAttribute(
        'value',
        quantity
      );

      this.dataset.selectedQuantity =
        quantity;

      this.updateDisplayedPrice(quantity);
    }

    formatMoney(priceInCents) {
      if (
        typeof window.theme?.formatMoney ===
        'function'
      ) {
        return window.theme.formatMoney(
          priceInCents,
          window.theme.moneyFormat
        );
      }

      return `$${(
        priceInCents / 100
      ).toFixed(2)}`;
    }

    getMainPriceContainer() {
      const productInfo =
        this.closest('product-info');

      if (!productInfo) {
        return null;
      }

      const sectionIds = [
        productInfo.dataset.section,
        productInfo.dataset.originalSection,
        this.dataset.sectionId
      ].filter(Boolean);

      for (const sectionId of sectionIds) {
        const priceContainer =
          productInfo.querySelector(
            `[id="Price-${CSS.escape(
              String(sectionId)
            )}"]`
          );

        if (priceContainer) {
          return priceContainer;
        }
      }

      return productInfo.querySelector(
        '[id^="Price-"]'
      );
    }

    updateDisplayedPrice(quantity) {
      if (
        !Number.isFinite(
          this.singlePriceInCents
        )
      ) {
        return;
      }

      const singlePrice =
        this.singlePriceInCents;

      /*
       * Pair price:
       * single price × 2
       */
      const pairOriginalPrice =
        singlePrice * 2;

      /*
       * Visual discount:
       * pair price minus 10%
       */
      const pairDiscountPrice =
        Math.round(
          pairOriginalPrice * 0.9
        );

      const priceContainer =
        this.getMainPriceContainer();

      if (priceContainer) {
        const priceContent =
          priceContainer.querySelector(
            '.product__price__wrap'
          ) || priceContainer;

        const pairPriceIsRendered =
          Boolean(
            priceContent.querySelector(
              '[data-charm-pair-price]'
            )
          );

        if (quantity === '2') {
          /*
           * Save the theme's original single-price
           * HTML before displaying the pair price.
           */
          if (!pairPriceIsRendered) {
            this.singlePriceHtml =
              priceContent.innerHTML;
          }

          priceContent.innerHTML = `
            <span data-charm-pair-price>
              <s class="charm-pair-price__original">
                ${this.formatMoney(
                  pairOriginalPrice
                )}
              </s>

              <span class="charm-pair-price__discounted">
                ${this.formatMoney(
                  pairDiscountPrice
                )}
              </span>
            </span>
          `;
        } else if (
          pairPriceIsRendered &&
          this.singlePriceHtml != null
        ) {
          /*
           * Restore the theme's original price
           * when Single is selected.
           */
          priceContent.innerHTML =
            this.singlePriceHtml;
        }
      }

      /*
       * Also update the price inside the
       * Add to Cart button when enabled.
       */
      const buttonPrice =
        this.productForm?.querySelector(
          '[data-product-price]'
        );

      if (!buttonPrice) {
        return;
      }

      if (quantity === '2') {
        buttonPrice.classList.add(
          'product__price--sale'
        );

        buttonPrice.innerHTML = `
          <s>
            ${this.formatMoney(
              pairOriginalPrice
            )}
          </s>

          ${this.formatMoney(
            pairDiscountPrice
          )}
        `;
      } else {
        buttonPrice.classList.remove(
          'product__price--sale'
        );

        buttonPrice.textContent =
          this.formatMoney(singlePrice);
      }
    }
  }

  customElements.define(
    'charm-purchase-options',
    CharmPurchaseOptions
  );
})();